import { render, staticRenderFns } from "./WeChat.vue?vue&type=template&id=299570e8&scoped=true"
import script from "./WeChat.vue?vue&type=script&lang=ts"
export * from "./WeChat.vue?vue&type=script&lang=ts"
import style0 from "./WeChat.vue?vue&type=style&index=0&id=299570e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299570e8",
  null
  
)

export default component.exports